import React from "react";
import { useSelector } from "react-redux";
import ArrowIcon from "../../assest/arrow.png";
import YesIcon from "../../assest/YesIcon.png";
   
// Translation dictionaries
const translations = {
  gb: {
    heading: "Why Choose Etihad Gharbia Contracting Company?",
    paragraph: "Etihad Gharbia delivers expert contracting, manpower, equipment rental, and transportation with integrity and innovation.",
    benefits: [
      "Trusted by Saudi Technic, Railways, Health, and Interior.",
      "Supplying quality equipment and skilled manpower across KSA.",
      "Delivering projects timely with uncompromised quality guaranteed.",
      "Expertise in contracting, equipment rental, manpower, transportation, IT solutions.",
    ],
    quickResponse: {
      title: "Quick Response",
      description: "Our expert team reviews your needs and responds within 24 hours with a tailored, comprehensive quote.",
    },
    form: {
      title: "Request Your Quote",
      fullNameLabel: "Full Name",
      fullNamePlaceholder: "Enter your name",
      phoneLabel: "Phone",
      phonePlaceholder: "Enter your phone number",
      emailLabel: "Email Address",
      emailPlaceholder: "Enter your email",
      serviceLabel: "Service Required",
      serviceOptions: [
        "General Contracting",
        "Equipment Rental",
        "Manpower Supply",
        "Transportation",
      ],
      messageLabel: "Project Details",
      messagePlaceholder: "Tell us more about your project...",
      submitButton: "Request Quote",
      agreementText: "By submitting, you agree to Etihad Gharbia's secure service policies.",
    },
  },
  sa: {
    heading: "لماذا تختار شركة اتحاد غربية للمقاولات؟",
    paragraph: "تقدم اتحاد غربية خدمات مقاولات متخصصة، قوى عاملة، تأجير معدات، ونقل بأمانة وابتكار.",
    benefits: [
      "موثوق بها من قبل التقنية السعودية، السكك الحديدية، الصحة، والداخلية.",
      "توفير معدات عالية الجودة وقوى عاملة ماهرة في جميع أنحاء المملكة.",
      "تسليم المشاريع في الوقت المحدد مع ضمان الجودة دون المساومة.",
      "خبرة في المقاولات، تأجير المعدات، القوى العاملة، النقل، وحلول تكنولوجيا المعلومات.",
    ],
    quickResponse: {
      title: "استجابة سريعة",
      description: "يقوم فريقنا المتخصص بمراجعة احتياجاتك والرد خلال 24 ساعة بعرض شامل ومخصص.",
    },
    form: {
      title: "طلب عرض أسعار",
      fullNameLabel: "الاسم الكامل",
      fullNamePlaceholder: "أدخل اسمك",
      phoneLabel: "رقم الهاتف",
      phonePlaceholder: "أدخل رقم هاتفك",
      emailLabel: "البريد الإلكتروني",
      emailPlaceholder: "أدخل بريدك الإلكتروني",
      serviceLabel: "الخدمة المطلوبة",
      serviceOptions: [
        "المقاولات العامة",
        "تأجير المعدات",
        "توفير القوى العاملة",
        "النقل",
      ],
      messageLabel: "تفاصيل المشروع",
      messagePlaceholder: "أخبرنا المزيد عن مشروعك...",
      submitButton: "طلب عرض أسعار",
      agreementText: "بتقديم الطلب، فإنك توافق على سياسات الخدمة الآمنة لاتحاد غربية.",
    },
  },
  fr: {
    heading: "Pourquoi choisir Etihad Gharbia Contracting Company ?",
    paragraph: "Etihad Gharbia fournit des services experts en contrats, main-d'œuvre, location d'équipements et transport avec intégrité et innovation.",
    benefits: [
      "Approuvé par Saudi Technic, Railways, Health, et Interior.",
      "Fourniture d'équipements de qualité et de main-d'œuvre qualifiée à travers l'Arabie Saoudite.",
      "Livraison des projets dans les délais avec une qualité garantie sans compromis.",
      "Expertise en contrats, location d'équipements, main-d'œuvre, transport, et solutions informatiques.",
    ],
    quickResponse: {
      title: "Réponse rapide",
      description: "Notre équipe d'experts examine vos besoins et répond dans les 24 heures avec un devis complet et personnalisé.",
    },
    form: {
      title: "Demandez votre devis",
      fullNameLabel: "Nom complet",
      fullNamePlaceholder: "Entrez votre nom",
      phoneLabel: "Téléphone",
      phonePlaceholder: "Entrez votre numéro de téléphone",
      emailLabel: "Adresse e-mail",
      emailPlaceholder: "Entrez votre e-mail",
      serviceLabel: "Service requis",
      serviceOptions: [
        "Entrepreneur général",
        "Location d'équipements",
        "Fourniture de main-d'œuvre",
        "Transport",
      ],
      messageLabel: "Détails du projet",
      messagePlaceholder: "Parlez-nous davantage de votre projet...",
      submitButton: "Demander un devis",
      agreementText: "En soumettant, vous acceptez les politiques de service sécurisées d'Etihad Gharbia.",
    },
  },
  de: {
    heading: "Warum die Etihad Gharbia Contracting Company wählen?",
    paragraph: "Etihad Gharbia bietet fachkundige Dienstleistungen in den Bereichen Auftragsvergabe, Arbeitskräfte, Geräteverleih und Transport mit Integrität und Innovation.",
    benefits: [
      "Vertrauen von Saudi Technic, Railways, Health und Interior.",
      "Bereitstellung hochwertiger Ausrüstung und qualifizierter Arbeitskräfte in ganz Saudi-Arabien.",
      "Pünktliche Lieferung von Projekten mit kompromissloser Qualität garantiert.",
      "Expertise in Auftragsvergabe, Geräteverleih, Arbeitskräfte, Transport und IT-Lösungen.",
    ],
    quickResponse: {
      title: "Schnelle Antwort",
      description: "Unser Expertenteam prüft Ihre Anforderungen und antwortet innerhalb von 24 Stunden mit einem maßgeschneiderten, umfassenden Angebot.",
    },
    form: {
      title: "Fordern Sie Ihr Angebot an",
      fullNameLabel: "Vollständiger Name",
      fullNamePlaceholder: "Geben Sie Ihren Namen ein",
      phoneLabel: "Telefon",
      phonePlaceholder: "Geben Sie Ihre Telefonnummer ein",
      emailLabel: "E-Mail-Adresse",
      emailPlaceholder: "Geben Sie Ihre E-Mail ein",
      serviceLabel: "Erforderliche Dienstleistung",
      serviceOptions: [
        "Allgemeine Bauarbeiten",
        "Geräteverleih",
        "Personalbereitstellung",
        "Transport",
      ],
      messageLabel: "Projektdetails",
      messagePlaceholder: "Erzählen Sie uns mehr über Ihr Projekt...",
      submitButton: "Angebot anfordern",
      agreementText: "Mit der Einreichung stimmen Sie den sicheren Dienstleistungsrichtlinien von Etihad Gharbia zu.",
    },
  },
};

const Quote = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  return (
    <section
      className="quote-section bg-dark text-white h-1200px py-5"
      dir={language === 'sa' ? 'rtl' : 'ltr'}
    >
      <div className="container">
        <div className="row justify-content-between align-items-center">
          {/* Left Side - Text Content */}
          <div className="col-lg-6 mb-5 mb-lg-0">
            <h2 className="fw-bold text-white mb-4">{t.heading}</h2>
            <p style={{ lineHeight: "1.7", maxWidth: "500px" }}>{t.paragraph}</p>

            <div
              className="d-flex flex-column gap-3 my-4"
              style={{ maxWidth: "400px" }}
            >
              {t.benefits.map((benefit, index) => (
                <div
                  className="d-flex align-items-center gap-3"
                  key={index}
                >
                  <img
                    src={YesIcon}
                    alt="check"
                    style={{ width: "24px", height: "24px" }}
                  />
                  <p className="mb-0">{benefit}</p>
                </div>
              ))}
            </div>

            <div
              style={{
                maxWidth: "500px",
                border: "1px solid white",
                padding: "15px",
                borderRadius: "8px",
              }}
            >
              <h3 className="text-white fw-bold mb-2">{t.quickResponse.title}</h3>
              <p className="border-b border-white pb-2">{t.quickResponse.description}</p>
            </div>
          </div>

          {/* Right Side - Form */}
          <div className="col-lg-6">
            <div className="bg-white text-dark p-4 rounded-4 shadow-sm">
              <form>
                <h4 className="text-center mb-4 fw-bold">{t.form.title}</h4>

                {/* First Row - Name & Phone */}
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label
                      htmlFor="name"
                      className="form-label fw-semibold"
                    >
                      {t.form.fullNameLabel}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder={t.form.fullNamePlaceholder}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label
                      htmlFor="phone"
                      className="form-label fw-semibold"
                    >
                      {t.form.phoneLabel}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="phone"
                      placeholder={t.form.phonePlaceholder}
                    />
                  </div>
                </div>

                {/* Email */}
                <div className="mb-3">
                  <label
                    htmlFor="email"
                    className="form-label fw-semibold"
                  >
                    {t.form.emailLabel}
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder={t.form.emailPlaceholder}
                  />
                </div>

                {/* Service */}
                <div className="mb-3">
                  <label
                    htmlFor="service"
                    className="form-label fw-semibold"
                  >
                    {t.form.serviceLabel}
                  </label>
                  <select className="form-select" id="service">
                    {t.form.serviceOptions.map((option, index) => (
                      <option key={index}>{option}</option>
                    ))}
                  </select>
                </div>

                {/* Message */}
                <div className="mb-4">
                  <label
                    htmlFor="message"
                    className="form-label fw-semibold"
                  >
                    {t.form.messageLabel}
                  </label>
                  <textarea
                    className="form-control"
                    id="message"
                    rows="4"
                    placeholder={t.form.messagePlaceholder}
                  ></textarea>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="btn btn-danger rounded-pill d-flex align-items-center gap-2 px-4 py-2"
                  style={{ transition: "all 0.3s ease", width: "fit-content" }}
                >
                  {t.form.submitButton}
                  <img
                    src={ArrowIcon}
                    alt="arrow"
                    style={{
                      width: "40px",
                      height: "40px",
                      transition: "transform 0.3s ease",
                    }}
                    className="arrow-hover"
                  />
                </button>
                <p className="text-center text-dark mt-2">{t.form.agreementText}</p>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Inline Hover Effect for Icon */}
      <style>{`
        .btn:hover .arrow-hover {
          transform: translateX(5px);
        }
        [dir="rtl"] .d-flex.align-items-center.gap-3 {
          flex-direction: row-reverse;
        }
        [dir="rtl"] .form-label {
          text-align: right;
        }
      `}</style>
    </section>
  );
};

export default Quote;